export type ReportType = "Monitoring" | "All";

export type TransferType = "Json" | "File";

export type Role =
  | "Admin"
  | "ClientGuest"
  | "ClientUser"
  | "ClientManager"
  | "CustomerGuest"
  | "CustomerUser"
  | "CustomerManager"
  | "CustomerEmployee";

export type RequestStatus =
  | "New"
  | "ReceivedByClient"
  | "RejectedByClient"
  | "SentByClient"
  | "ReceivedByCustomer"
  | "RejectedByCustomer"
  | "AcceptedByCustomer";

export type RequestTab =
  | "FinStatements"
  | "DebtBurdens"
  | "Sales"
  | "Counterparties"
  | "Analysis"
  | "Summary"
  | "Dashboard"
  | "DQ";

export type RecordType =
  | "Month"
  | "ThreeMonths"
  | "SixMonths"
  | "NineMonths"
  | "Year"
  | "FirstQuarter"
  | "SecondQuarter"
  | "ThirdQuarter"
  | "FourthQuarter";

export type FnsStatus =
  | "CreatedByAccounter"
  | "CreatedFromBills"
  | "Sent"
  | "Accepted"
  | "Rejected";

export type DynamincsOfPaymentsFilters =
  | "Currency"
  | "Counterparties"
  | "Banks"
  | "AffiliatedEntities"
  | "typesOperationsTable"
  | "numberOfTransactionsByTypesOperationsTable"
  | "numberOfTransactionsByCounterpartiesTable"
  | "transactionMonitoringTable";

export type RegularInflowsAndOutflowsFilters =
  | "InflowQuantity"
  | "OutflowQuantity";

export type ChangeInPaymentProfileFilters = "Currency" | "PaymentPurpose";

export type DashboardFilters =
  | "Currency"
  | "Counterparties"
  | "Banks"
  | "AffiliatedEntities"
  | "Amount"
  | "Type";

export enum FileType {
  OneSPlugin = 1,
  OneSPluginFresh = 2,
  UserManualOneSPlugin = 3,
  UserManualOneSPluginFresh = 4,
  UserManualFreshWithDigitalSignature = 5,
  UserManualOneSFinOtchetnost = 6,
  UserManualSmartan = 7,
  FAQ = 8,
}

export type IntegrationFile = {
  id: string;
  createdAt: string;
  updatedAt: string;
  mimeType: string;
  fileName: string;
  fileType: string;
  fileTypeDescription: string;
};

export type StopFactorStatus = "Yes" | "No" | "NoData" | "NotApplicable";

export type StopFactorResult = {
  key: string;
  displayName: string;
  /** null — критерий ещё не считали */
  status: StopFactorStatus | null;
  value: string;
};

export type StopFactorReport = {
  /** null — расчёт ещё не выполнялся */
  calculatedAt: Date | null;
  triggeredCount: number | null;
  items: StopFactorResult[];
};

export type StopFactorSetting = {
  key: string;
  displayName: string;
  isEnabled: boolean;
};

export type StopFactorOwner = {
  type: "lead" | "client";
  id: string;
  /** Для лида: чьи настройки и результаты показывать — генератора или приёмника. */
  customerId?: string;
  name: string;
  inn: string;
};
